import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { asyncConnect } from 'react-async-client';
import { Row, Col } from 'antd';
import Translate from 'react-translate-component';

import { getEducationTimesheet } from 'actions/asyncActions';
import { fullAutoOptions } from 'constants/asyncClient';
import { DATE_FORMATS } from 'constants/dateFormats';
import withTranslateChange from 'components/hocs/withTranslateChange';
import StaticTable from 'components/common/tableComponents/StaticTable';
import RefreshButton from 'components/common/controls/RefreshButton';
import { DateField, TimeRangeField } from 'components/common/fields/DateTimeFields';
import RangePicker from 'components/common/controls/RangePicker';

const PERSON_TIMESHEET_PARAMS = {
    participant: 1,
    trainer: 0
};

@asyncConnect({
    getEducationTimesheet: getEducationTimesheet
        .withDefaultPayload(({ dateto, datefrom, project }) => ({
            dateto: dateto && dateto.format(DATE_FORMATS.parse),
            datefrom: datefrom && datefrom.format(DATE_FORMATS.parse),
            project,
            ...PERSON_TIMESHEET_PARAMS
        }))
        .withOptions(fullAutoOptions)
})
@withTranslateChange(({ getEducationTimesheet: { refresh } }) => refresh())
export default class PersonTimetableTable extends Component {
    static propTypes = {
        project: PropTypes.string.isRequired,
        dateto: PropTypes.object,
        datefrom: PropTypes.object,
        getEducationTimesheet: PropTypes.object.isRequired,
        setDateRange: PropTypes.func.isRequired
    }

    tableColumns = [
        {
            name: 'number',
            width: 60,
            additionalClass: 'p-l-15',
            template: ({ rowIndex }) => rowIndex + 1
        },
        {
            name: 'name',
            width: 200,
            label: <Translate content="education.event.name" />,
            additionalClass: 'p-l-15',
            template: ({ item: { name } }) => name
        },
        {
            name: 'date',
            width: 120,
            label: <Translate content="events.date" />,
            template: ({ item: { date } }) => <DateField date={date} />
        },
        {
            name: 'dateFrom',
            width: 120,
            label: <Translate content="events.dateFrom" />,
            template: ({ item: { dt: { date = {} } } }) => <DateField date={date.from} />
        },
        {
            name: 'dateTo',
            width: 120,
            label: <Translate content="events.dateTo" />,
            template: ({ item: { dt: { date = {} } } }) => <DateField date={date.to} />
        },
        {
            name: 'timePeriod',
            width: 120,
            label: <Translate content="events.time" />,
            template: ({ item: { dt: { time } } }) => <TimeRangeField time={time} />
        },
        {
            name: 'trainers',
            additionalClass: 'p-l-15',
            label: <Translate content="events.trainer" />,
            template: ({ item: { trainers = [] } }) => <div>
                { trainers.map(({ trainer }) => <div key={trainer.id}>{trainer.name}</div>) }
            </div>
        },
    ]

    render() {
        const { getEducationTimesheet: { data, meta, refresh }, datefrom, dateto, setDateRange } = this.props;
        const value = [datefrom, dateto];

        return (
            <div className="person-timetable">
                <Row className="react-table-controls list-controls">
                    <Col span={14} className='range-picker m-t-10'>
                        <RangePicker allowClear={false} setDateRange={setDateRange} value={value} />
                    </Col>
                    <Col span={10} className="text-right icon-bar">
                        <RefreshButton refreshMeta={meta} handleRefresh={refresh} />
                    </Col>
                </Row>
                <StaticTable
                    meta={meta}
                    refresh={refresh}
                    items={data.items}
                    className="width-auto-table"
                    columns={this.tableColumns}
                />
            </div>
        )
    }
}
